// src/Pages/AnnouncementsPage.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnnouncementTable from '../Component/AnnouncementTable';
import { fetchStoresThunk } from '../features/stores/storeThunks';
import Sidebar from '../Component/Sidebar';
const AnnouncementsPage = () => {
  const dispatch = useDispatch();
  const { stores, loading: storesLoading } = useSelector((state) => state.stores);

  // Fetch stores when component mounts (needed for filters)
  useEffect(() => {
    if (stores.length === 0) {
      dispatch(fetchStoresThunk());
    }
  }, [dispatch, stores.length]);

  return (
      <div className='index-box'>
      <Sidebar />
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Store Announcements</h1>
        <p style={styles.subtitle}>
          Track and manage store announcements with role-based permissions
        </p>
      </div>

      {storesLoading ? (
        <div style={styles.loading}>Loading stores...</div>
      ) : (
        <AnnouncementTable />
      )}
    </div>
        </div>

  );
};

const styles = {
  container: {
    padding: '24px',
    width: '80%',
    margin: '0 ',
    backgroundColor: '#f8f9fa',
    minHeight: '100vh',
  },
  header: {
    marginBottom: '24px',
    backgroundColor: 'white',
    padding: '24px',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '28px',
    fontWeight: '600',
    color: '#212529',
    margin: '0 0 8px 0',
  },
  subtitle: {
    fontSize: '16px',
    color: '#6c757d',
    margin: 0,
  },
  loading: {
    textAlign: 'center',
    padding: '40px',
    fontSize: '16px',
    color: '#6c757d',
  },
};

export default AnnouncementsPage;